module.exports = __webpack_public_path__ + "media/images/flags/32/Scotland-aff4aaa18e1b90f36285977c1b7aca0f.png";